import { Component, ElementRef, ViewChild, OnInit, ViewContainerRef, ComponentFactoryResolver, HostListener } from '@angular/core';
import { AspMyRequestService } from '../../auto-spare-parts/asp-my-request/asp-my-request.service';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AspLoadingService } from '../asp-loading/asp-loading.service'; 
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';
import { Location } from '@angular/common';
import { GlobalVariable } from 'app/main/globals';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';


interface FilterOption {
  label: string;
  value: string;
  checked: boolean;
  children?: FilterOption[];
}

interface Filters {
  insuranceStatus:FilterOption[];
  requestStatus: FilterOption[];
  requestTime: FilterOption[];
}

@Component({
  selector: 'app-asp-my-request',
  templateUrl: './asp-my-request.component.html',
  styleUrls: ['./asp-my-request.component.scss']
})
export class AspMyRequestComponent implements OnInit {
  emptyList: any = 'assets/images/no-cart.png';
  @ViewChild('filterSection', { static: false }) filterSection!: ElementRef;

  filters: Filters = {
    
    insuranceStatus: [
      { label: 'Insurance', value: '1', checked: false },
    ],
    requestStatus: [
      { label: 'Requested', value: '1', checked: false },
      { label: 'Quote Received', value: '8', checked: false },
      { label: 'Quote Approved', value: '9', checked: false },
      { label: 'Order Created', value: '4', checked: false },
      { label: 'Cancelled', value: '0', checked: false },
    ],
    requestTime: [
      { label: 'Today', value: 'TODAY', checked: false },
      { label: 'Yesterday', value: 'YESTERDAY', checked: false },
      { label: 'Last 7 days', value: 'LAST_7_DAYS', checked: false },
      { label: 'Last 30 days', value: 'LAST_30_DAYS', checked: false },
      { label: 'This month', value: 'THIS_MONTH', checked: false },
      { label: 'Last Month', value: 'LAST_MONTH', checked: false },
      { label: 'Any Time', value: 'ANY_TIME', checked: false }
    ]
  };

  requestList: any[] = [];
  filteredRequestList: any[] = [];
  searchTerm: string = '';
  selectedRequestStatus: string = '';
  selectedRequestTime: string = '';
  make: any = '';
  statusCount: { [key: string]: number } = {};
  showClearIcon: boolean;
  filterOrders: any;
  requestDetails: any;
  list: any;
  isInputVisible: boolean = false;


  @ViewChild(MatSort, { static: false }) sort: MatSort;
  getRelevance: any;
  isMobile: boolean;
  isSidebarOpen: boolean;
  loading: boolean;
  insurerGarageKey: string;
  insurance: any;
  isInsurance: boolean;
  selectedType: string;
  showError: boolean;
  searchText: any;
  selectedCompany: string;
  filteredList: string[];
  insuranceCompanies: string[] = [
    'ICICI Lombard',
    'HDFC ERGO',
    'Bajaj Allianz',
    'Tata AIG',
    'New India Assurance'
  ];
  showError1: boolean;
  showPopupinfo: boolean;
  selectedRequestInsurance: string = '';
  openEdit: boolean;
  openEditIndex: number | null = null;
  requestaId: any;
  insuranceGarageId: any;
  data: any;
  requestedType: 'garage' | 'agent' = 'agent';
  constructor(
    private aspMyRequestService: AspMyRequestService,
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private aspLoadingService: AspLoadingService,
    private resolver: ComponentFactoryResolver,
    private location: Location,
    public toastr: ToastrService,
    private route: ActivatedRoute
  ) {
      this.breakpointObserver.observe([Breakpoints.Handset])
    .subscribe(result => {
      this.isMobile = result.matches;
    }); }

  ngOnInit(): void {
    localStorage.removeItem('addMoreItemsId');
     this.route.queryParams.subscribe(params => {
    if (params['status']) {
      this.selectedRequestStatus = params['status'];
      this.filterRequest();
    }
  });
      this.setDefaultDateFilter();
    
    this.getInsurance();
    this.getList();
    // const savedRequestStatus = localStorage.getItem('selectedRequestStatus');
    // const savedRequestTime = localStorage.getItem('selectedRequestTime');

    // if (savedRequestStatus) {
    //     this.selectedRequestStatus = savedRequestStatus;
    //     this.filters.requestStatus.forEach(status => {
    //         status.checked = (status.value === savedRequestStatus);
    //     });
    // }

    // if (savedRequestTime) {
    //     this.selectedRequestTime = savedRequestTime;
    //     this.filters.requestTime.forEach(time => {
    //         time.checked = (time.value === savedRequestTime);
    //         if (time.children) {
    //             time.children.forEach(child => {
    //                 child.checked = (child.value === savedRequestTime);
    //             });
    //         }
    //     });
    // }

    this.filterRequest();
  }
//  ngAfterViewInit() {
//     this.getInsurance();

//   }
setDefaultDateFilter() {
  const today = new Date().getDate();
  let defaultValue = '';

  if (today >= 1 && today <= 14) {
    defaultValue = 'LAST_30_DAYS';
  } else {
    defaultValue = 'THIS_MONTH';
  }

  this.selectedRequestTime = defaultValue;  // store main selected

  // Update UI flags exactly like your existing logic
  this.filters.requestTime.forEach(time => {
    time.checked = (time.value === defaultValue);

    if (time.children) {
      time.children.forEach(child => {
        child.checked = (child.value === defaultValue);
      });
    }
  });
   this.getAppliedFilters()
}

  sidecontainer() {
    this.isSidebarOpen = !this.isSidebarOpen; // Toggle the sidebar open/close state
  }
  
  navigateToRequestDetails(): void {
    this.router.navigate(['request-details']); 
  }
  // getMakeImageUrl(make: string): string {
  //   return `https://cube.getpitstop.com/assets/img/${make.toLowerCase()}.png`;
  // }

  getMakeImageUrl(make: string): string {
    const makeWithoutSpaces = make.toLowerCase().replace(/\s+/g, '');
    return `https://cube.getpitstop.com/assets/img/${makeWithoutSpaces}.png`;
  }
  

  getStatusMessage(statusDetails: { [key: string]: number } | undefined): string {
    // console.log(statusDetails);
    if (!statusDetails) return '⏳ Requested';    
    
    if (statusDetails['4'] || statusDetails['10']) {
      return '📦 Order Created';
    } else if (statusDetails['9']) {
      return '✅ Quote Approved';
    } else if (statusDetails['8']) {
      return '💬 Quote Received';
    } else if (statusDetails['1']) {
      return '⏳ Requested';
    } else if (statusDetails['0']) {
      return '❌ Cancelled';
    } else {
      return '⏳ Requested';
    }
  }
//   getStatusMessage(statusDetails: { [key: string]: number } | undefined): string {
//     if (!statusDetails) return '⏳ Requested';    
    
//     if (statusDetails['4']) {
//       return '🧾 Order Created';
//     } else if (statusDetails['9']) {
//       return '✅ Quote Approved';
//     } else if (statusDetails['8']) {
//       return '💬 Quote Received';
//     } else if (statusDetails['1']) {
//       return '⏳ Requested';
//     } else {
//       return '⏳ Requested';
//     }
// }

  // toggleSelection(filterType: keyof Filters, option: FilterOption) {
    
  //   if (filterType === 'requestStatus') {
  //     this.filters.requestStatus.forEach(status => {
  //       status.checked = (status.value === option.value);
  //     });
  //     this.selectedRequestStatus = option.value;

  //   } else if (filterType === 'requestTime') {
  //     this.filters.requestTime.forEach(time => {
  //       time.checked = (time.value === option.value);
  //       if (time.children) {
  //         time.children.forEach(child => {
  //           child.checked = (child.value === option.value);
  //         });
  //       }
  //     });
  //     this.selectedRequestTime = option.value;
  //   }
  //   this.filterRequest();
  // }
  toggleSelection(filterType: keyof Filters, option: FilterOption) {
    if (filterType === 'requestStatus') {
        // Update request status filters
        this.filters.requestStatus.forEach(status => {
            status.checked = (status.value === option.value);
        });
        this.selectedRequestStatus = option.value;
    } else if (filterType === 'requestTime') {
        // Update request time filters
        this.filters.requestTime.forEach(time => {
            time.checked = (time.value === option.value);
            if (time.children) {
                time.children.forEach(child => {
                    child.checked = (child.value === option.value);
                });
            }
        });
        this.selectedRequestTime = option.value;
        
      this.getList()
    }else if (filterType === 'insuranceStatus') {
        // Update request time filters
        this.filters.insuranceStatus.forEach(insurance => {
            insurance.checked = (insurance.value === option.value);
        });
        this.selectedRequestInsurance = option.value;
    }

    // Save selected request status and request time to localStorage
    localStorage.setItem('selectedRequestStatus', this.selectedRequestStatus);
    localStorage.setItem('selectedRequestTime', this.selectedRequestTime);
    localStorage.setItem('selectedRequestInsurance', this.selectedRequestInsurance);

    
    // console.log('selectedRequestStatus', this.selectedRequestStatus);
    // console.log('selectedRequestTime', this.selectedRequestTime);
    // console.log('selectedRequestInsurance', this.selectedRequestInsurance);

    this.filterRequest();
}


// clearFilters() {
//   // Reset selected filter values
//   this.selectedRequestStatus = '';
//   this.selectedRequestTime = '';

//   // Function to uncheck all options recursively
//   const clearOptions = (options: FilterOption[]) => {
//       options.forEach(option => {
//           option.checked = false;
//           if (option.children) {
//               clearOptions(option.children);
//           }
//       });
//   };

//   // Clear all filter options in filters object
//   (Object.keys(this.filters) as (keyof Filters)[]).forEach(requestTimeKey => {
//       clearOptions(this.filters[requestTimeKey]);
//   });

//   // Clear filters in localStorage
//   localStorage.removeItem('selectedRequestStatus');
//   localStorage.removeItem('selectedRequestTime');

//   // Call filterRequest to update the displayed data
//   this.filterRequest();
// }
clearFilters() { 
  this.aspLoadingService.show();

  setTimeout(() => {
    // Reset filter selections
    this.selectedRequestStatus = '';
    this.selectedRequestInsurance = '';
    this.filters.requestStatus.forEach(f => f.checked = false);
    this.filters.requestTime.forEach(f => f.checked = false);

    localStorage.removeItem('selectedRequestStatus');
    localStorage.removeItem('selectedRequestTime');

    this.filteredRequestList = [...this.requestList];
    this.searchTerm = '';
    this.showClearIcon = false;
    this.isInputVisible = false;

    // If date filter was selected → reset and reload list
    if (this.selectedRequestTime !== '') {
      this.selectedRequestTime = '';
      this.getList(); // <-- THIS MUST STAY INSIDE THE setTimeout
    } else {
      this.aspLoadingService.hide(); // hide only if not calling getList()
    }

  }, 100);
}




  hasAppliedFilters(): boolean {
    return this.selectedRequestStatus !== '' || this.selectedRequestTime !== '' || this.selectedRequestInsurance !=='';
  }
appliedFilters: { requestTime: keyof Filters, option: FilterOption }[] = [];

  getAppliedFilters() {
    const appliedFilters: { requestTime: keyof Filters, option: FilterOption }[] = [];

    const addFilter = (requestTimeKey: keyof Filters, option: FilterOption) => {
      if (option.checked) {
        appliedFilters.push({ requestTime: requestTimeKey, option });
      }
    };

    (Object.keys(this.filters) as (keyof Filters)[]).forEach(requestTimeKey => {
      this.filters[requestTimeKey].forEach(option => {
        addFilter(requestTimeKey, option);
        if (option.children) {
          option.children.forEach(child => {
            addFilter(requestTimeKey, child);
          });
        }
      });
    });

    this.appliedFilters = appliedFilters;
  }

  removeFilter(requestTimeKey, option: FilterOption) { 
    option.checked = false;
    
    if (requestTimeKey === 'requestStatus') {
      this.selectedRequestStatus = '';
    } else if (requestTimeKey === 'requestTime') {
      this.selectedRequestTime = '';
      this.getList();
    }  else if (requestTimeKey === 'insuranceStatus') {
      this.selectedRequestInsurance = '';
    }
    this.filterRequest();
  }

  getList() {
    this.aspLoadingService.show();
    this.data=[];
    const range = this.getDateRange(this.selectedRequestTime);
    let spareUserKey = localStorage.getItem('spareUserKey');
    let garageKey = localStorage.getItem('garageKey');
    let roleType = localStorage.getItem("roleType");
    // console.log("roleType ",roleType);
    let type = localStorage.getItem('type');
    // console.log("type",type);
    if (type === "insurance")
    {
      this.insurerGarageKey= localStorage.getItem('garageKey')
    }else{
      this.insurerGarageKey = null;
    }
    // console.log("this.insurerGarageKey",this.insurerGarageKey);
      // Build payload dynamically
  let payload: any = {
    userKey: spareUserKey,
    garageKey:garageKey,
    source: "web",
    magicQuote: this.isOn,
    insurerGarageKey: this.insurerGarageKey
  };

  // Add date range ONLY if present
  if (range.startDate && range.endDate) {
    payload.startDate = range.startDate;
    payload.endDate = range.endDate;
  }
    this.aspMyRequestService.myRequest(payload).subscribe(
      result => {
        // console.log("my-request-response",result)
        let res = JSON.parse(JSON.stringify(result));
        if (res.code === 200) {
          this.loading = false;
          this.data=res.data;
          this.aspLoadingService.hide();
          this.requestList = res['data'].items.sort((a, b) => {    
            return new Date(b.requestDetails.requestedDate).getTime() - new Date(a.requestDetails.requestedDate).getTime();
          });
          this.filteredRequestList = res.data.items;
          // console.log("this.filteredRequestList",this.filteredRequestList)
          this.make = res.data.items;
          this.computeStatusCounts();
          // console.log("Variant Key:", this.filteredRequestList[0].requestDetails.variantKey);
          // console.log("filteredrequestlist---",this.make);
          localStorage.setItem("variantKey",this.filteredRequestList[0].requestDetails.variantKey);
          this.filterRequest();
          this.applySourceFilter();
        } else {
          this.loading = false;
          this.aspLoadingService.hide();
        }
      }
    );
  }
  getDateRange(filter: string): { startDate: string | null, endDate: string | null } {
  const now = new Date();

  const format = (date: Date) =>
    date.toISOString().split('T')[0]; // YYYY-MM-DD

  switch (filter) {
    case 'TODAY':
      return {
        startDate: format(now),
        endDate: format(now)
      };

    case 'YESTERDAY':
      const y = new Date(now);
      y.setDate(y.getDate() - 1);
      return {
        startDate: format(y),
        endDate: format(y)
      };

    case 'LAST_7_DAYS':
      const weekAgo = new Date(now);
      weekAgo.setDate(now.getDate() - 7);
      return {
        startDate: format(weekAgo),
        endDate: format(now)
      };

    case 'LAST_30_DAYS':
      const monthAgo = new Date(now);
      monthAgo.setDate(now.getDate() - 30);
      return {
        startDate: format(monthAgo),
        endDate: format(now)
      };

    case 'THIS_MONTH': {
  const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  const thisMonthEnd = new Date(
    now.getFullYear(),
    now.getMonth() + 1,
    0,
    23, 59, 59, 999
  );

  return {
    startDate: format(thisMonthStart),
    endDate: format(thisMonthEnd)
  };
}


    case 'LAST_MONTH':
      const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
      return {
        startDate: format(lastMonthStart),
        endDate: format(lastMonthEnd)
      };

    case 'ANY_TIME':
    default:
      return { startDate: null, endDate: null };
  }
}

    // filterRequest() {
  //   const term = this.searchTerm.trim().toLowerCase(); // convert search term to lowercase
  //   this.filteredRequestList = this.requestList.filter(request => {
  //     let statusMatch;
  //     if (request.statusDetails) {
  //       Object.keys(request.statusDetails).some(key => {
  //         statusMatch = this.selectedRequestStatus ? key === this.selectedRequestStatus : true;
  //       });
  //     }
  //     const timeMatch = this.selectedRequestTime
  //       ? this.filterByTime(request.requestDetails.requestedDate, this.selectedRequestTime)
  //       : true;
  //     const searchMatch = term ? (
  //       (request.requestDetails.requestId && request.requestDetails.requestId.toLowerCase().includes(term)) ||
  //       (request.requestDetails.regNo && request.requestDetails.regNo.toLowerCase().includes(term)) ||
  //       (request.requestDetails.claimNo && request.requestDetails.claimNo.toLowerCase().includes(term)) ||
  //       (request.requestDetails.claimType && request.requestDetails.claimType.toLowerCase().includes(term)) ||
  //       (request.requestDetails.make && request.requestDetails.make.toLowerCase().includes(term)) ||
  //       (request.requestDetails.model && request.requestDetails.model.toLowerCase().includes(term)) ||
  //       (request.requestDetails.fuelType && request.requestDetails.fuelType.toLowerCase().includes(term))
  //     ) : true;
  //     return statusMatch && timeMatch && searchMatch;
  //   });
  // }
  filterRequest() {
    
    const term = this.searchTerm.trim().toLowerCase();
    // Define priority: higher index = higher priority
    const priorityOrder = ['1','8','9','4','0']; // Requested < Received < Approved < Order Created

    this.filteredRequestList = this.requestList.filter(request => {
      if (!request.statusDetails) return false;

      // Determine the highest priority status present in this request
      let highestStatus = null;
      for (let i = priorityOrder.length - 1; i >= 0; i--) {
        if (request.statusDetails[priorityOrder[i]]) {
          highestStatus = priorityOrder[i];
          break;
        }
      }

      // Check if this request matches the selected filter
      let statusMatch = true;
      if (this.selectedRequestStatus) {
        statusMatch = this.selectedRequestStatus === highestStatus;
      }
  let insuranceMatch = true;
      if (this.selectedRequestInsurance) {
        insuranceMatch = this.selectedRequestInsurance === request.requestDetails.isInsurance;
      }
      // Filter by time if selected
      const timeMatch = this.selectedRequestTime
        ? this.filterByTime(request.requestDetails.requestedDate, this.selectedRequestTime)
        : true;

      // Filter by search term if any (including claimType and claimNo)
      const searchMatch = term
        ? (
            (request.requestDetails.requestId?.toLowerCase().includes(term)) ||
            (request.requestDetails.regNo?.toLowerCase().includes(term)) ||
            (request.requestDetails.make?.toLowerCase().includes(term)) ||
            (request.requestDetails.model?.toLowerCase().includes(term)) ||
            (request.requestDetails.fuelType?.toLowerCase().includes(term)) ||
            (request.requestDetails.itemNames?.toLowerCase().includes(term)) ||
            (request.requestDetails.claimNo?.toLowerCase().includes(term)) ||
            (request.requestDetails.claimType?.toLowerCase().includes(term)) 
          )
        : true;
      return statusMatch && timeMatch && searchMatch && insuranceMatch;
    });
    this.getAppliedFilters();
  }

  filterByTime(requestTime: string, filter: string): boolean {
    const now = new Date();
    const requestDate = new Date(requestTime);

    switch (filter) {
      case 'TODAY':
        return requestDate.toDateString() === now.toDateString();
      case 'YESTERDAY':
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        return requestDate.toDateString() === yesterday.toDateString();
      case 'LAST_7_DAYS':
        const weekAgo = new Date(now);
        weekAgo.setDate(now.getDate() - 7);
        return requestDate >= weekAgo && requestDate <= now;
      case 'LAST_30_DAYS':
        const monthAgo = new Date(now);
        monthAgo.setDate(now.getDate() - 30);
        return requestDate >= monthAgo && requestDate <= now;
      case 'THIS_MONTH':
        const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        return requestDate >= thisMonthStart && requestDate < nextMonthStart;    
      case 'LAST_MONTH':
        const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
        const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
        return requestDate >= lastMonthStart && requestDate <= lastMonthEnd;
      case 'ANY_TIME':
      default:
        return true;
    }
  }

  computeStatusCounts() {
    this.statusCount = this.requestList.reduce((counts, request) => {
      if (request.statusDetails) {
        Object.keys(request.statusDetails).forEach(status => {
          counts[status] = (counts[status] || 0) + request.statusDetails[status];
        });
      }
      
      return counts;
    }, {} as { [key: string]: number });
  }

toggleInputVisibility() {
  this.isInputVisible = true; // stops scroll
}


// onInputChange() {
//   this.showClearIcon = this.searchTerm && this.searchTerm.length > 0;
//   // Apply filter in real time as user types / deletes
//   this.filterRequest();
// }
onInputChange() {
  this.showClearIcon = !!this.searchTerm;

  if (this.searchTerm) {
    // Typing or deleting characters but not empty: filter immediately
    this.filterRequest();
  } else {
    // Input completely cleared: show loader immediately
    this.loading = true;
    this.aspLoadingService.show();

    // Use requestAnimationFrame to let browser render loader immediately
    requestAnimationFrame(() => {
      // Defer updating filtered list to next tick
      setTimeout(() => {
        this.filteredRequestList = [...this.requestList];
        this.isInputVisible = false;
        this.showClearIcon = false;

        // Hide loader
        this.loading = false;
        this.aspLoadingService.hide();
      }, 0);
    });
  }
}

  clearSearch() {
  // Show loading
  this.loading = true;
  this.aspLoadingService.show();

  setTimeout(() => {
    this.searchTerm = '';
    this.showClearIcon = false;
    this.isInputVisible = false;
    this.filteredRequestList = [...this.requestList];

    // Hide loader
    this.loading = false;
    this.aspLoadingService.hide();
  }, 100);
}


  // Method to sort suggestions by relevance
// sortSuggestionsByRelevance(suggestions: string[], searchText: string): string[] {
//   return suggestions.sort((a, b) => {
//       const relevanceA = this.getRelevance(a, searchText);
//       const relevanceB = this.getRelevance(b, searchText);
//       return relevanceB - relevanceA; // Higher relevance comes first
//   });
// }
navigateToDetails(id: string) {
  this.router.navigate(['/request-details'], { queryParams: {"id": id}})
}
 isOn = false;

toggle(event: any) {
  this.clearFilters()
    this.isOn = event.target.checked;
    // console.log('Toggle is:', this.isOn ? 'ON' : 'OFF');
    this.getList();
  }
  // Calculate total items
getTotalItems(statusDetails: { [key: string]: number } | undefined): number {
  if (!statusDetails) return 0;
  return Object.values(statusDetails).reduce((sum, val) => sum + val, 0);
}
  @ViewChild('intstantorder', { read: ViewContainerRef }) containers!: ViewContainerRef;
  loadInstantDetails() {
    //  this.container.clear();

    if(this.insurance.length>0 && !(localStorage.getItem('instantOrder') == '2')){
      this.isInsurance=true
    }else{
    
    const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.containers.createComponent(factory);

    const componentBInstance = componentRef.instance as AspInstantRequestComponent;

            // Toggle the form sidebar (instead of the confirmation sidebar)
        if(localStorage.getItem('instantOrder')  && localStorage.getItem('instantOrder') == '2'){
          // this.loadorderdetails();
    
        componentBInstance.closeDetails(true);  
            componentBInstance.openSidebar(true);
      }
      else{
        componentBInstance.closeDetails(false); 
        componentBInstance.openSidebar(true);
          localStorage.removeItem('carNumber');
      }
    }
  }
shareRequestViaWhatsApp(request: any) {
  this.aspLoadingService.show();

  if (!request) {
    console.warn('Request not provided.');
    this.aspLoadingService.hide();
    return;
  }

  const requestId = request.requestDetails.requestId || '';
  const regNo = request.requestDetails.regNo || '';
  const vehicleMake = request.requestDetails.make || '';
  const vehicleModel = request.requestDetails.model || '';
  const vehicleFuel = request.requestDetails.fuelType || '';
  const vehicleYear = request.requestDetails.manufacturingYear || '';
  const vehicleVariant = request.requestDetails.variant || '';

  // ✅ Parse the JSON string to get the array
  let itemQuantityArray: any[] = [];
  try {
    itemQuantityArray = JSON.parse(request.requestDetails.itemNameQuantities || '[]');
  } catch (err) {
    console.error('Error parsing itemNameQuantities:', err);
    itemQuantityArray = [];
  }

  let partsList = '';
  if (itemQuantityArray.length > 0) {
    // Map each part with its quantity
    partsList = itemQuantityArray
      .map((item: any) => ` → ${item.name} - ${item.quantity} unit${item.quantity > 1 ? 's' : ''}`)
      .join('\n');
  } else {
    // fallback to old itemNames string
    const requestedParts = request.requestDetails.itemNames || '';
    partsList = requestedParts
      ? requestedParts.split(',').map((item: string) => ` → ${item.trim()} - 1 unit`).join('\n')
      : ' → No parts listed';
  }

  // ✅ Construct WhatsApp message
  const message =
    `*🔔 New Request Raised via Magic Flow!*\n\n` +
    `Hello Autoverse Team,\n\n` +
    `*Request ID:* ${requestId}\n` +
    `*Car:* ${vehicleMake} ${vehicleModel} ${vehicleYear} ${vehicleVariant} - ${vehicleFuel} (${regNo})\n\n` +
    `*Requested Parts:*\n${partsList}\n\n` +
    `⏳ Please *share the quotation with price & availability on the system urgently* so we can confirm without delay.\n\n` +
    `👉 Click here to view your Request:${GlobalVariable.AUTOVERSE_WEB}/request/request-details?id=${requestId}`;

  const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank');

  this.aspLoadingService.hide();
}
getInsurance(){
    this.aspMyRequestService.getInsurance().subscribe(
      result => {
        // console.log("result",result);
        this.insurance=result['data']
            const navState: any = this.location.getState();
    if (navState?.triggerFunction) {
      this.loadInstantDetails();
    }
    if(localStorage.getItem('instantOrder')=='2'){
    this.loadInstantDetails();
    }
      })
  
}
goBackList(){
    this.isInsurance=false;
    this.selectedType='';
    this.selectedCompany = '';
    this.insuranceGarageId='';
    this.showError = false;
    this.showError1 = false;
    this.openEdit=false;
}
  selectType(type: string): void {
    this.selectedType = type;
    this.showError = false;   
    if (type === 'insurance') {
      if(this.insurance.length<=1){
        this.selectCompany(this.insurance[0])
      }else{
      this.filteredList = [...this.insurance]; // show all initially
      }
    } else {
      this.selectedCompany = null;
      this.searchText = '';
    }
  }
  continue(): void {
    if (!this.selectedType  ) {
      this.showError = true; 
    }else if(this.selectedType=="insurance" && !this.selectedCompany){
      this.showError1 = true; 
    }else{
    this.isInsurance=false;
      let type;
      if(this.selectedType=="insurance"){
         type=true;
      }else{
         type=false;
      }
      localStorage.setItem("isInsurance", type);
      localStorage.setItem('insuranceGarageKey', this.selectedCompany);
           const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.containers.createComponent(factory);

    const componentBInstance = componentRef.instance as AspInstantRequestComponent;

            // Toggle the form sidebar (instead of the confirmation sidebar)
        if(localStorage.getItem('instantOrder')  && localStorage.getItem('instantOrder') == '2'){
          // this.loadorderdetails();
    
        componentBInstance.closeDetails(true);  
            componentBInstance.openSidebar(true);
      }
      else{
        componentBInstance.closeDetails(false); 
        componentBInstance.openSidebar(true);
          localStorage.removeItem('carNumber');
      }
    }
  }
  skip(){
  this.openEdit=false;
    this.isInsurance=false;
      localStorage.removeItem("isInsurance");
      localStorage.removeItem('insuranceGarageKey');
     const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.containers.createComponent(factory);

    const componentBInstance = componentRef.instance as AspInstantRequestComponent;

            // Toggle the form sidebar (instead of the confirmation sidebar)
        if(localStorage.getItem('instantOrder')  && localStorage.getItem('instantOrder') == '2'){
          // this.loadorderdetails();
    
        componentBInstance.closeDetails(true);  
            componentBInstance.openSidebar(true);
      }
      else{
        componentBInstance.closeDetails(false); 
        componentBInstance.openSidebar(true);
          localStorage.removeItem('carNumber');
      }
     this.isInsurance=false;

  }
    

  onSearchChange(): void {
    const query = this.searchText.trim().toLowerCase();
    if (!query) {
      this.filteredList = [...this.insurance];
    } else {
      this.filteredList = this.insurance.filter(c =>
        c.insuranceGarageName.toLowerCase().includes(query)
      );
    }
  }
    selectCompany(company: string): void {
      
    this.showError1 = false;   
    this.selectedCompany = company['insuranceGarageKey'];
    this.insuranceGarageId=company['insuranceGarageId'];
    // console.log('Selected company:', company);
  }
  get isContinueActive(): boolean {
  // active if non-insurance, or insurance + company selected
  return (
    this.selectedType === 'non-insurance' ||
    (this.selectedType === 'insurance' && !!this.selectedCompany)
  );
}
showPopup(){
  this.showPopupinfo=true;
}
closePopup(){
  this.showPopupinfo=false;
}
toggleEditMenu(index: number, event: Event) {
  event.stopPropagation();
  this.openEditIndex = this.openEditIndex === index ? null : index;
}

@HostListener('document:click')
closeAllMenus() {
  this.openEditIndex = null;
}

editRequest(request: any) {
  // console.log('Editing:', request);
  this.requestaId=request;
  this.openEdit=true;
  this.openEditIndex = null;
  this.isInsurance=true;
}
updateInsurance(){
     if (!this.selectedType  ) {
      this.showError = true; 
    }else if(this.selectedType=="insurance" && !this.selectedCompany){
      this.showError1 = true; 
    }else{
  let type;
      if(this.selectedType=="insurance"){
         type=true;
      }else{
         type=false;
      }
    let insurerId;
      if(this.selectedCompany==null){
        insurerId = 0;
      }else{
        insurerId=this.insuranceGarageId;
      }
     this.aspMyRequestService.UpdateInsurance(this.requestaId,type,insurerId).subscribe(
      result => {
        // console.log("result", result);
        this.toastr.success(result['response'].message);
        
    this.aspLoadingService.show();
    
    this.clearFilters();
    this.getList();
  this.goBackList()
      })
}
}
addMoreItems(list: any) {
// console.log("list", list);
  // 🔹 Store selected vehicle (sidebar reads from here)
  localStorage.setItem('carNumber', list.regNo || list.registrationNumber);
  localStorage.setItem('selectedMake', list.make);
  localStorage.setItem('selectedModel', list.model);
  localStorage.setItem('variant', list.variant);
  localStorage.setItem('fuelType', list.fuelType);
  localStorage.setItem('selectedYear', list.manufacturingYear);
  localStorage.setItem('variantKey', list.variantKey);
  localStorage.setItem('rowKey', list.rowKey);
  localStorage.setItem('addMoreItemsId', list.requestId);

  // 🔹 Create sidebar dynamically
  const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
  const componentRef = this.containers.createComponent(factory);
  const componentInstance = componentRef.instance as AspInstantRequestComponent;

  // 🔹 Open ONLY Parts Entry sidebar
  componentInstance.closeDetails(false);        // optional (if details must close)
  componentInstance.closetext(true);       // ✅ THIS is what you want
}
onTypeChange(type: 'garage' | 'agent') {
  this.requestedType = type;
  this.applySourceFilter();
}
applySourceFilter() {
  if (!this.requestList) return;

  this.filteredRequestList = this.requestList.filter(item => {
    const source = item?.requestDetails?.createdSource?.toLowerCase();

    if (this.requestedType === 'garage') {
      return source === 'garage';
    }

    if (this.requestedType === 'agent') {
      return source === 'agent' || !source; // empty treated as agent
    }

    return true;
  });
}
}
